module.exports = __webpack_public_path__ + "static/media/SO.4a1a4d82.png";